/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { StaticAssetKey } from "./StaticAssetKey";

export interface OutputImageStaticPart {
  type: "output_image_static";
  asset_key: StaticAssetKey;
  alt_text?: string | null;
}
